import React from 'react'
import { Image, Button, Modal } from "react-bootstrap";
import {
    ModalButton,
    ModalTitle,
} from './unPublishModalStyle'
import NonprofitImage from '../../../assests/images/nonprofitmimg.svg';
interface UnpublishProps {
    editUnpublishOpen: boolean;
    setEditUnpublishOpen: (val: boolean) => void;
    confirmUnpublish: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const UnPublishModal: React.FC<UnpublishProps> = ({ editUnpublishOpen, setEditUnpublishOpen, confirmUnpublish }: any) => {
    return (
        <Modal show={editUnpublishOpen} className='claim-nonprofit-modal'
            onHide={() => setEditUnpublishOpen(false)} centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>

                <ModalTitle>Are You Sure You want to Unpublish this review?</ModalTitle>
                <ModalButton>
                    <Button className='fill-btn modal-btn' onClick={confirmUnpublish}>Confirm</Button>
                    <Button className='blank-btn modal-btn' onClick={() => setEditUnpublishOpen(false)}>Cancel</Button>
                </ModalButton>
            </Modal.Body>

        </Modal>
    )
}

export default UnPublishModal;
